// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {store} from './store/store'
import BootstrapVue from 'bootstrap-vue'

import SlideUpDown from 'vue-slide-up-down'

Vue.component('slide-up-down', SlideUpDown)

Vue.use(BootstrapVue)


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  components: { 
    App
  },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js